import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import IconTooltipButton from "../../../../button/IconTooltipButton";
import { useSelector } from "react-redux";
import DataGrid from "../../../../table/DataGrid";
import Avatar from "../../../../avatar/Avatar";
import DialogAddUsers from "./DialogAddUsers";
import { useParams } from "react-router-dom";

const FormUsers = ({ userType, isLoading, onChangeAlert, type }) => {
  const years = useSelector((state) => state?.tenant?.years || [])
  const formData = useSelector((state) => state?.class?.form || {});

  const { id } = useParams();

  const [columnsTable, setColumsTable] = useState([]);
  const [form, setForm] = useState([]);
  const [dialog, setDialog] = useState(null);

  useEffect(() => {
    if (type?.indexOf("add") > -1) {
      setForm([]);
    } else {
      setForm(formData?.[userType] || []);
    }
  }, []);

  useEffect(() => {
    let columnsTable = [];
    if (userType === "students") {
      columnsTable = [
        {
          label: "Photo",
          key: "avatar",
          align: "center",
          className: "text-center",
          show: true,
          hide: false
        },
        { label: "Code", key: "code", show: true, hide: true },
        { label: "Name", key: "fullName", show: true, hide: true },
        {
          label: "Year Level",
          key: "yearLevelUser",
          show: true,
          hide: true,
        }
      ];
    }

    if (userType === "teachers") {
      columnsTable = [
        {
          label: "Photo",
          key: "avatar",
          align: "center",
          className: "text-center",
          show: true,
          hide: false
        },
        { label: "Code", key: "code", show: true, hide: true },
        { label: "Name", key: "fullName", show: true, hide: true },
        { label: "Email", key: "email", show: true, hide: true },
      ];
    }

    setColumsTable(columnsTable);
  }, [userType]);

  const onRemoveConfirm = (row) => {
    const users = form.filter((item) => item._id !== row._id);
    const remove = formData.remove || [];
    setForm(users);
    remove.push(row);
    onChangeAlert(id ? 'remove' : userType, id ? remove : users);
  };

  const onAdd = (users) => {
    let newUsers = [];
    if (id) {
      newUsers = users;
    } else {
      newUsers = [...form, ...users];
    }
    onChangeAlert(id ? 'add' : userType, newUsers);
    setForm(newUsers);
  };

  useEffect(() => {
    if (!id) {
      setForm(formData?.[userType] || []);
    }
  }, [formData]);

  return (
    <>
      <Box
        className={[
          "px-4 py-2 h-6 flex items-center justify-between bg-primary text-primary-foreground",
        ].join(" ")}
      >
        <div className="flex gap-4 items-center">
          <Typography
            variant="inherit"
            className="font-bold capitalize"
            component="p"
          >
            {type?.replace(/-/g, " ")}
          </Typography>
        </div>
        <div>
          {type?.indexOf("add") > -1 && (
            <IconTooltipButton
              title={`Add ${userType}`}
              icon="plus"
              classNameIcon="text-lg"
              style={{
                borderRadius: "0.5rem",
                padding: "0.45rem",
                color: "var(--primary)",
                backgroundColor: "#fff",
                width: 25,
                height: 25,
              }}
              className="shadow-sm"
              onClick={() => setDialog(true)}  
            />
          )}
        </div>
      </Box>
      <Box className="absolute top-36 bottom-0 inset-x-4">
        <DataGrid
          id={`add-remove-${userType}`}
          showSetting={false}
          loading={isLoading}
          rows={form?.map((row, index) => {
            const data = row.data || {};
            const yearLevel = years?.find((item) => item._id === data.yearLevel)?.name

            return {
              ...row,
              index: index + 1,
              fullName: `${row?.preferredName || row?.firstName} ${row?.lastName}`,
              ...data,
              yearLevelUser: yearLevel,
              avatar: <div className='flex items-center justify-center'>
                <Avatar 
                  size='small'
                  variant='circular'
                  alt={row?.code}
                  src={`photos/${row?.photo}`}
                />
              </div>,
              actions: (
                <div className="flex items-center gap-1 items-center justify-center">
                  <IconTooltipButton
                    id={`delete-${row._id}`}
                    disabled={isLoading}
                    title="Delete"
                    icon="trash-alt"
                    onClick={() => onRemoveConfirm(row)}
                  />
                </div>
              ),
            };
          })}
          rowsPerPage={form?.length || 0}
          columns={[
            {
              label: "#",
              key: "index",
              align: "center",
              width: 10,
              show: true,
              hide: false,
            },
            ...columnsTable,
            {
              label: "Actions",
              key: "actions",
              align: "center",
              width: 50,
              show: true,
              hide: false,
            },
          ]}
          labelNoRows={`You don't have any ${userType} yet`}
        />
      </Box>
      { dialog &&
        <DialogAddUsers 
          open={dialog}
          onClose={() => setDialog(null)}
          userIds={[...formData[userType]?.map((item) => item._id)]}
          onAdd={onAdd}
          columnsTable={columnsTable}
          userType={userType}
          type={type}
        />
      }
    </>
  );
};

export default FormUsers;
